var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M11.052 1.75c.528 0 .957.428.957.957v5.981c0 2.179-1.54 4.004-3.59 4.445v12.16c0 .529-.428.957-.956.957-.529 0-.957-.428-.957-.957v-12.16c-2.049-.441-3.59-2.266-3.59-4.445V2.707c0-.529.43-.957.958-.957s.957.428.957.957v5.981c0 1.452 1.18 2.632 2.632 2.632 1.45 0 2.631-1.18 2.631-2.632V2.707c0-.529.429-.957.958-.957zm9.379 0c1.274 0 2.473.907 3.376 2.553.733 1.334 1.17 2.974 1.17 4.385 0 2.179-1.54 4.004-3.59 4.445v12.16c0 .529-.428.957-.956.957-.529 0-.957-.428-.957-.957v-12.16c-2.049-.441-3.59-2.266-3.59-4.445 0-1.411.438-3.05 1.17-4.385.903-1.646 2.102-2.553 3.377-2.553zm0 1.914c-.52 0-1.171.598-1.699 1.56-.576 1.049-.933 2.376-.933 3.464 0 1.452 1.18 2.632 2.632 2.632 1.45 0 2.631-1.18 2.631-2.632 0-1.088-.357-2.415-.933-3.465-.527-.961-1.178-1.559-1.698-1.559zM7.463 1.75c.528 0 .957.428.957.957v5.838c0 .528-.429.957-.957.957-.529 0-.957-.429-.957-.957V2.707c0-.529.428-.957.957-.957z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDining);
export default __webpack_public_path__ + "static/media/account_dining.fbfc6d089444d00b2987d61a65f52292.svg";
export { ForwardRef as ReactComponent };